export default () => {
  let headers = {
    'ApiKey': process.env.VUE_APP_BASE_API_KEY,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
  return headers
}
